"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBuilderService = void 0;
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-param-reassign */
/**
 * ADP Utils
 * @author Micaela Lopez <micaela.lopez@autodesk.com>
 */
const pickBy_1 = __importDefault(require("lodash/pickBy"));
const Utils = __importStar(require("./Utils"));
const Common_1 = require("./Common");
const Fingerprint_1 = require("./Fingerprint");
const UserService_1 = require("./UserService");
const Events_1 = require("./Events");
class MessageBuilderService {
    constructor(contextService, facetFilterService, userService) {
        this.contextService = contextService;
        this.facetFilterService = facetFilterService;
        this.userService = userService;
        this.fingerprint = new Fingerprint_1.Fingerprint();
    }
    collectFacets(eventType, opFacets) {
        const facets = opFacets !== null && opFacets !== void 0 ? opFacets : {};
        Utils.facetsCoercion(facets);
        if (this.contextService.context.user != null) {
            const { userIntent } = this.contextService.context;
            facets.user = Object.assign({ info: [this.contextService.context.user] }, (userIntent ? { intent: userIntent } : undefined));
        }
        if (facets.browser == null) {
            facets.browser = this.fingerprint.browserFacet();
        }
        if (facets.device == null) {
            facets.device = this.fingerprint.deviceFacet();
        }
        if (facets.page) {
            facets.page = Object.assign(Object.assign({}, this.contextService.context.facets.page), facets.page);
        }
        const pickedCtxFacets = (0, pickBy_1.default)(this.contextService.context.facets, (value, key) => facets[key] == null);
        Object.assign(facets, pickedCtxFacets);
        return this.contextService.context.config.facetBasedFiltering === true
            ? this.facetFilterService.doWhitelistFiltering(eventType, facets)
            : facets;
    }
    /**
     * Creates the message to be sent to ASE services
     * @param eventType
     * @param opFacets operation facets
     * @param consentMetric
     * @returns {Message | Error}
     * @private
     */
    buildMsg(eventType, opFacets, consentMetric) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const facets = this.collectFacets(eventType, opFacets);
            if (facets == null) {
                return new Error("The event is filtered out by whitelist filtering");
            }
            const consentMetricData = consentMetric !== null && consentMetric !== void 0 ? consentMetric : (yield this.userService.readConsentMetric());
            if (consentMetricData instanceof UserService_1.NoConsentError) {
                return consentMetricData;
            }
            facets.user.consent_metric = consentMetricData;
            const data = {
                // API Settings
                version: Common_1.SCHEMA_VERSION,
                sdk_version: Common_1.SDK_VERSION,
                status: "OK",
                session_id: this.contextService.context.session_id,
                device_id: this.contextService.context.device_id,
                // App Settings
                user_id: (_a = this.contextService.context.user) === null || _a === void 0 ? void 0 : _a.user_id,
                provider_name: (_b = this.contextService.context.user) === null || _b === void 0 ? void 0 : _b.provider_name,
                device_time: Utils.timestamp(new Date()),
                event_id: Utils.genGuid(),
                type: Events_1.EVENTS[eventType].type,
                scope: Events_1.EVENTS[eventType].scope,
                cur_service_id: this.contextService.context.cur_service_id,
                cur_service_name: this.contextService.context.cur_service_name,
                module_name: "ASE",
                method_name: "/upload",
                facets: [],
            };
            if (this.contextService.context.projectId) {
                data.user_project_id = this.contextService.context.projectId;
            }
            if (this.contextService.context.projectUrn) {
                data.user_project_urn = this.contextService.context.projectUrn;
            }
            if (this.contextService.context.hubId) {
                data.user_hub_id = this.contextService.context.hubId;
            }
            if (this.contextService.context.hubUrn) {
                data.user_hub_urn = this.contextService.context.hubUrn;
            }
            Object.entries(facets)
                .filter(([facet, facetValue]) => facet !== "any" && facetValue != null)
                .forEach(([facet, facetValue]) => {
                data.facets.push(facet);
                Object.entries(facetValue)
                    .filter(([, value]) => value != null)
                    .filter(([, value]) => typeof value !== "object" || Object.keys(value).length)
                    .forEach(([key, value]) => {
                    data[`${facet}_${key}`] = value;
                });
            });
            return data;
        });
    }
}
exports.MessageBuilderService = MessageBuilderService;
